export default class DateFactory {

    public static newDate(): Date {
        return new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
    }
}